import i18n, { COUNTRY_TO_LOCALE, DEFAULT_LOCALE, SUPPORTED_LOCALES } from "../i18n/index.js";

const CACHE_KEY = "tt_geo_country";
const CACHE_TS_KEY = "tt_geo_country_ts";
const CACHE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

function readCache() {
  try {
    const ts = Number(localStorage.getItem(CACHE_TS_KEY));
    const v = localStorage.getItem(CACHE_KEY);
    if (v && ts && Date.now() - ts < CACHE_MS) return v;
  } catch {}
  return null;
}

function writeCache(country) {
  try {
    localStorage.setItem(CACHE_KEY, country);
    localStorage.setItem(CACHE_TS_KEY, String(Date.now()));
  } catch {}
}

// Free, no-key endpoint that returns { country: "RO", ip: "..." }.
// Swap to Cloudflare CF-IPCountry header injection (via Worker) once we go orange-cloud.
async function fetchCountry() {
  try {
    const res = await fetch("https://api.country.is/", { mode: "cors" });
    if (!res.ok) throw new Error(`country.is HTTP ${res.status}`);
    const json = await res.json();
    return (json.country || "").toUpperCase() || null;
  } catch {
    return null;
  }
}

export async function getCountry() {
  const cached = readCache();
  if (cached) return cached;
  const country = await fetchCountry();
  if (country) writeCache(country);
  return country;
}

export function localeForCountry(country) {
  if (!country) return DEFAULT_LOCALE;
  return COUNTRY_TO_LOCALE[country.toUpperCase()] || DEFAULT_LOCALE;
}

// First-visit redirect helper. If the user lands on '/' and we can geolocate
// them, redirect to the matching locale prefix. Idempotent — only fires once
// per session, and never overrides an explicit URL choice.
export async function maybeRedirectToGeoLocale(navigate, location) {
  if (sessionStorage.getItem("tt_geo_redirected") === "1") return false;
  const path = location.pathname || "/";
  const first = path.split("/").filter(Boolean)[0];
  if (first && SUPPORTED_LOCALES.includes(first)) return false; // already on a locale URL
  if (path !== "/" && first) return false; // some other route — leave alone
  const country = await getCountry();
  const locale = localeForCountry(country);
  sessionStorage.setItem("tt_geo_redirected", "1");
  if (locale && locale !== DEFAULT_LOCALE) {
    navigate(`/${locale}${path === "/" ? "" : path}`, { replace: true });
    return true;
  }
  return false;
}
